import { IRawStyle } from "@fluentui/react";
import React from "react";
import { FormProvider, UseFormMethods } from "react-hook-form";

import { AssociateContentFormFields } from "../components/AssociateContentFormFields";
import { ContentAssociationValidation } from "../types/AssociateContentFormValidationRules";
import { ContentAssociationFormState } from "../types/ContentAssociationFormState";

interface AssociateContentEmbeddedFormProps<T extends ContentAssociationFormState> {
    form: UseFormMethods<T>;
    defaultContentState?: ContentAssociationFormState;
    isDefaultContentLoading: boolean;
    validation?: ContentAssociationValidation;
    onInactiveContentSelectionChange?: (value: boolean) => void;
    renderLabelSection?: boolean;
    isEditDisabled?: boolean;
    infoMessage?: string;
    style?: IRawStyle;
}

export const AssociateContentEmbeddedForm = <T extends ContentAssociationFormState>(
    props: AssociateContentEmbeddedFormProps<T>
): JSX.Element => {
    const {
        form,
        defaultContentState,
        isDefaultContentLoading,
        validation,
        isEditDisabled,
        infoMessage,
        style,
        renderLabelSection,
        onInactiveContentSelectionChange
    } = props;

    return (
        <FormProvider {...form}>
            <AssociateContentFormFields
                renderLabelSection={renderLabelSection}
                defaultContentState={defaultContentState}
                isDefaultContentLoading={isDefaultContentLoading}
                onInactiveContentSelectionChange={onInactiveContentSelectionChange}
                validation={validation}
                isEditDisabled={isEditDisabled}
                infoMessage={infoMessage}
                style={style}
            />
        </FormProvider>
    );
};
